import {
  getFirestore,
  onSnapshot,
  doc,
  where,
  query,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  collection,
  serverTimestamp,
  deleteDoc,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import lodash from "lodash";
import { TYPES } from "./job.type";
import { REF } from "../ref";
import { app } from "../../config/config";
import moment from "moment";

const firestore = getFirestore(app);
const auth = getAuth(app);

// -------------- Add a job -------------- //
export const addJob =
  ({ job }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.JOB);
    //query the job today
    const branch = job?.branch;
    const start = moment().startOf("day").toDate();
    const end = moment().endOf("day").toDate();
    const c0 = where("branch", "==", branch);
    const c1 = where("bookingAt", ">=", start);
    const c2 = where("bookingAt", "<=", end);
    const qRef = query(cRef, c0, c1, c2);
    getDocs(qRef)
      .then((snapshot) => {
        if (snapshot) {
          const jobList = snapshot.docs.map((doc) => doc.data());
          const jobLength = jobList ? jobList?.length : 0;
          const name = `${moment().format("YYYYMMDD")}-${jobLength + 1}`;
          const id = doc(cRef).id;
          const dRef = doc(cRef, id);
          const data = {
            ...job,
            id,
            createAt: serverTimestamp(),
            name,
          };

          setDoc(dRef, data, { merge: true })
            .then(() => {
              if (callback) {
                callback({
                  status: 200,
                  data: data,
                });
              }
            })
            .catch((err) => {
              if (callback) {
                callback({
                  status: 500,
                  data: err?.message || "Please try again!",
                });
              }
            });
        }
      })
      .catch((err) => console.log(err));
  };

// -------------- select all job  -------------- //
let jobsub = [];
export const snapJobByBranch =
  ({ from, to, branch }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.JOB);
    const start = moment(from).startOf("day").toDate();
    const end = moment(to).endOf("day").toDate();
    const c0 = where("branch", "==", branch);
    const c1 = where("bookingAt", ">=", start);
    const c2 = where("bookingAt", "<=", end);
    const qRef = query(cRef, c0, c1, c2);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        selectAllJobSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });
    jobsub.push(unsub);
  };

export const unSnapJob = () => (dispatch) => {
  jobsub.forEach((subscriber) => {
    subscriber();
  });

  jobsub.length = 0;
};

// -------------- dispatch -------------- //
const selectAllJobSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_ALL_JOB_SUCCESS,
    payload: data,
  });
};

// -------------- Delete Job by Id  -------------- //
export const deleteJobById =
  ({ id }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.JOB);
    const dRef = doc(cRef, id);
    deleteDoc(dRef)
      .then(() => {
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((err) => {
        if (callback) {
          callback({
            status: 500,
            data: err?.message || "Please try again!",
          });
        }
      });
  };

// -------------- Update Job by Id  -------------- //
export const updateJobById =
  ({ id, update }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.JOB);
    const dRef = doc(cRef, id);

    let updated = {
      ...update,
      updateAt: serverTimestamp(),
    };
    updateDoc(dRef, updated)
      .then(() => {
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((err) => {
        if (callback) {
          callback({
            status: 500,
            data: err?.message || "Please try again!",
          });
        }
      });
  };

// ------------- get Jobs by voucher Id --------------------------------

export const getJobsByVoucherId =
  ({ voucherId }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.JOB);
    const c0 = where("giftId", "==", voucherId);
    const qRef = query(cRef, c0);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        if (data) {
          selectJobsByVoucherSuccess(dispatch, data);
          if (callback) {
            callback({
              status: 200,
            });
          }
        } else {
          if (callback) {
            callback({
              status: 500,
              data: "No code was found!",
            });
          }
        }
      }
    });
  };

// ---------------------- dispatch --------------------------------

const selectJobsByVoucherSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_JOB_LIST_SUCCESS,
    payload: data,
  });
};

// ---------------------- get income by date --------------------------------

export const getIncomeByDate =
  ({ date, branch }, callback) =>
  (dispatch) => {
    selectIncomeSuccess(dispatch, null);
    const cRef = collection(firestore, REF.INCOME_STAFF);
    const c0 = where("date", "==", date);
    const c1 = where("branch", "==", branch);
    const qRef = query(cRef, c0, c1);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const [dataIncome] = snapshot.docs.map((doc) => doc.data());
        if (callback) {
          callback(dataIncome);
        }
      } else {
        if (callback) {
          callback(false);
        }
      }
    });
  };

//---------------- dispatch ----------------

const selectIncomeSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_ALL_INCOME_SUCCESS,
    payload: data,
  });
};

// -------------- get Staff by ids -------------
export const getStaffsByIds =
  ({ ids }, callback) =>
  (dispatch) => {
    selectStaffByIdsSuccess(dispatch, null);
    const cRef = collection(firestore, REF.USER);
    let result = [];
    const promises = lodash.chunk(ids, 9)?.map((arr) => {
      const c0 = where("id", "in", arr);
      const qRef = query(cRef, c0);
      return getDocs(qRef).then((snapshot) => {
        if (snapshot) {
          const data = snapshot.docs.map((doc) => doc.data());
          result.push(...data);
        }
      });
    });

    Promise.all(promises)
      .then(() => {
        selectStaffByIdsSuccess(dispatch, result);
        if (callback) {
          callback({
            status: 200,
            data: result,
          });
        }
      })
      .catch((err) => {
        if (callback) {
          callback({
            status: 500,
            data: err?.message,
          });
        }
      });
  };

//dispatch
const selectStaffByIdsSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_STAFF_BY_IDS_SUCCESS,
    payload: data,
  });
};

// update staff of  job
export const updateJobByStaff =
  ({ id, update }, callback) =>
  (dispatch) => {
    console.log(id, update);
    const cRef = collection(firestore, REF.JOB);
    const c0 = where("id", "==", id);
    const qRef = query(cRef, c0);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        if (data) {
          const dRef = doc(cRef, id);
          let staffs = data[0]?.staffs || [];
          let subStaff = staffs?.filter(
            (staff) => staff?.userId !== update?.userId
          );
          const newIncome = update?.value ? [update] : [];
          staffs = [...subStaff, ...newIncome];
          setDoc(dRef, { staffs }, { merge: true })
            .then(() => {
              if (callback) {
                callback({
                  status: 200,
                });
              }
            })
            .catch((err) => {
              if (callback) {
                callback({
                  status: 500,
                  data: err?.message || "Please try again!",
                });
              }
            });
        } else {
          if (callback) {
            callback({
              status: 500,
              data: "No job was found!",
            });
          }
        }
      }
    });
  };

// snapJob by Id
let snapJobSub = [];
export const snapJobDetailById =
  ({ id }, callback) =>
  (dispatch) => {
    selectJobDetailSuccess(dispatch, null);
    const cRef = collection(firestore, REF.JOB);
    const c0 = where("id", "==", id);
    const qRef = query(cRef, c0);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        if (data?.length > 0) {
          selectJobDetailSuccess(dispatch, data[0]);
          if (callback) {
            callback({ status: 200, data: data[0] });
          }
        }
      }
    });
    snapJobSub.push(unsub);
  };

export const unSnapJobDetail = () => (dispatch) => {
  snapJobSub.forEach((subscriber) => {
    subscriber();
  });

  snapJobSub.length = 0;
};

//dispatch
const selectJobDetailSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_JOB_DETAIL_BY_ID_SUCCESS,
    payload: data,
  });
};


// lock job
export const lockJobById =
  ({ id, update }, callback) =>
  (dispatch) => {
    console.log(id, update);
    const cRef = collection(firestore, REF.JOB);
    const c0 = where("id", "==", id);
    const qRef = query(cRef, c0);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        if (data) {
          const dRef = doc(cRef, id);
          let lockAt = data[0]?.lockAt;
          const locked = lockAt ? moment(lockAt.toDate()) > moment() : false;
          if (!locked) {
            const newLocckAt = moment().add(1, "minute").toDate();
            setDoc(dRef, { lockAt: newLocckAt }, { merge: true })
              .then(() => {
                if (callback) {
                  callback({
                    status: 200,
                  });
                }
              })
              .catch((err) => {
                if (callback) {
                  callback({
                    status: 500,
                    data: err?.message || "Please try again!",
                  });
                }
              });
          } else {
            if (callback) {
              callback({
                status: 500,
                data: "Job is locked!",
              });
            }
          }
        } else {
          if (callback) {
            callback({
              status: 500,
              data: "No job was found!",
            });
          }
        }
      }
    });
  };